<template>
  <div class="rf-retention-modal-preview">
    <div
      v-if="model.device_type === 'web' || model.path_type === 'bottom_banner'"
      style="width: 100%; height: 100%"
    >
      <div :class="webPreviewClass">
        <template v-if="model.device_type === 'web'">
          <RfRetentionDeviceWeb
            v-if="model.path_type === 'retention_modal' || model.path_type === 'video'"
            ref="web"
            :model="model"
            :actionGroupId="actionGroupId"
            :actions="actions"
            :viewTypeTab="viewTypeTab"
            :retentionTypeVideo="model.path_type === 'video'"
            @clickTab="onClickTab"
          />
          <RfRetentionInterstitial
            v-if="model.path_type === 'interstitial' || model.path_type === 'widget'"
            ref="web"
            :model="model"
            :actionGroupId="actionGroupId"
            :actions="actions"
            :viewTypeTab="viewTypeTab"
            @clickTab="onClickTab"
          />
        </template>
        <RfRetentionBanner
          v-if="model.path_type === 'bottom_banner'"
          ref="web"
          :model="model"
          :actionGroupId="actionGroupId"
          :actions="actions"
          :viewTypeTab="viewTypeTab"
          @clickTab="onClickTab"
        />
      </div>
    </div>
    <RfRetentionDeviceIos
      v-if="model.device_type === 'ios' && model.path_type !== 'bottom_banner'"
      ref="ios"
      :model="model"
      :actions="actions"
      :viewTypeTab="viewTypeTab"
      @clickTab="onClickTab"
    />
    <RfRetentionDeviceTvOs
      v-if="isTvDevice && model.path_type !== 'bottom_banner'"
      ref="tv"
      :model="model"
      :actions="actions"
      :viewTypeTab="viewTypeTab"
      :retentionTypeVideo="model.path_type === 'video'"
      @clickTab="onClickTab"
    />
    <RfRetentionDeviceAndroidOs
      v-if="model.device_type === 'android_os' && model.path_type !== 'bottom_banner'"
      ref="android_os"
      :model="model"
      :actions="actions"
      :viewTypeTab="viewTypeTab"
      @clickTab="onClickTab"
    />
  </div>
</template>

<script setup>
import { computed, useTemplateRef } from "vue";
import RfRetentionDeviceWeb from "@/components/RfPathCreate/RfRetentionDevices/RfRetentionDeviceWeb.vue";
import RfRetentionInterstitial from "@/components/RfPathCreate/RfRetentionDevices/RfRetentionInterstitial.vue";
import RfRetentionDeviceIos from "@/components/RfPathCreate/RfRetentionDevices/RfRetentionDeviceIos.vue";
import RfRetentionDeviceTvOs from "@/components/RfPathCreate/RfRetentionDevices/RfRetentionDeviceTvOs.vue";
import RfRetentionDeviceAndroidOs from "@/components/RfPathCreate/RfRetentionDevices/RfRetentionDeviceAndroidOs.vue";
import RfRetentionBanner from "@/components/RfPathCreate/RfRetentionDevices/RfRetentionBanner.vue";

const props = defineProps({
  model: { type: Object, required: true },
  actions: { type: Object, default: () => ({}) },
  viewTypeTab: { type: String, default: "desktopViewTab" },
  actionGroupId: { type: [String, Number], default: undefined },
  webPreviewClass: { type: String, default: "" },
});

const emit = defineEmits(["clickTab"]);

const web = useTemplateRef("web");
const ios = useTemplateRef("ios");
const tv = useTemplateRef("tv");
const android_os = useTemplateRef("android_os");

const isTvDevice = computed(() =>
  ["tv_os", "roku_os", "android_tv", "custom_defined"].includes(props.model.device_type),
);

const onClickTab = tabType => emit("clickTab", tabType);

const fillModel = async model => {
  for (const os of [web, ios, tv, android_os]) {
    if (os.value) await os.value.fillModel(model);
  }
};

defineExpose({ fillModel });
</script>
